import { Toaster } from 'react-hot-toast';

const Notifications = () => <Toaster position={'top-right'} />;

export { Notifications };
